<template>
  <CRow>
    <CCol sm="12" xs="12" md="12" lg="12" xl="12" class="text-center"> </CCol>
    <CCol sm="12" xs="12" md="3" lg="3" xl="3">
      <CCard>
        <header class="card-header w-100">
          <b>COBROS DEL D&Iacute;A</b>
          <button
            @click="mtdBack"
            type="button"
            class="btn btn-sm text-white float-right"
            style="background: #e46666"
          >
            <i class="fas fa-hand-point-left"></i> Ir a Inicio
          </button>
        </header>
      </CCard>
      <CCard
        v-for="(item, index) in level"
        :key="index"
        @click="mtdSelectLevel(index)"
        :class="mtdGetClassCommand(index)"
      >
        <CCardHeader class="text-center text-uppercase font-weight-bold">
          {{ item.name }}
        </CCardHeader>
      </CCard>
    </CCol>
    <CCol sm="12" xs="12" md="9" lg="9" xl="9" v-if="posSelectLevel >= 0">
      <CCard>
        <CCardBody id="area-canva">
          <div
            class="position-relative border rounded bg-light"
            style="width: 100%; height: 500px; overflow: hidden"
          >
            <button
              v-for="(mesa, index) in level[posSelectLevel].detalle.filter(
                (m) => m.position
              )"
              :key="index"
              type="button"
              :class="mtdGetStayteAtention(mesa.state_attention)"
              :style="{
                top: mesa.y + 'px',
                left: mesa.x + 'px',
                padding: '0.5rem',
                fontSize: '0.9rem',
              }"
              @click="mtdSelectTable(index)"
            >
              <i class="fas fa-table"></i> {{ mesa.name }}
            </button>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
    <!-- component full -->
    <cModalFullComand v-model="modalFull.showModal">
      <template #header>
        <h5 class="modal-title">{{ modalFull.title }}</h5>
      </template>

      <div style="min-height: 500px">
        <CRow>
          <CCol xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
            <CRow>
              <CCol
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                xxl="12"
                class="text-center"
                ><h3>
                  TOTAL: S/. <b>{{ cpTotalComand }}</b>
                </h3></CCol
              >
              <CCol
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                xxl="12"
                class="text-left"
                v-if="command.length > 0"
              >
                <CButton
                  v-for="(item, pos) in command"
                  :key="pos"
                  class="w-100"
                  block
                  variant="outline"
                  :color="mtdGetClassItemCommand(item.state)"
                  @click="mtdSelectItemComand(item, pos)"
                >
                  <b
                    ><i v-if="item.status == 3" class="fas fa-ban"></i> ({{
                      item.quantity
                    }}) {{ item.name }} | {{ item.price_key }} | S/{{
                      parseFloat(item.price * item.quantity).toFixed(2)
                    }}</b
                  >
                  <br />
                  <span>{{ mtdGetStateItemCommand(item.state) }}</span>
                  <br />
                  {{ item.anotation }}
                  <br />
                  <small style="color: #666"
                    >Haz clic para cambiar precio</small
                  >
                </CButton>
              </CCol>
              <CCol v-else xs="12" sm="12" md="12" lg="12" xl="12" xxl="12"
                ><h5>aun no tiene pedidos!!!</h5></CCol
              >
            </CRow>
          </CCol>
          <CCol xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
            <CRow>
              <div
                v-for="(item, index) in data_comprobante_pago"
                :key="index"
                :class="[
                  'col',
                  colClass,
                  'd-flex',
                  'font-bold',
                  item.selected ? 'bg-info' : 'bg-gris',
                  'container-type',
                ]"
                @click="selectItem(item.value)"
              >
                <div class="text text-center">{{ item.label }}</div>
              </div>
            </CRow>
            <CRow class="mt-2">
              <CCol sm="12" lg="4">
                <CInput
                  :label="isFactura ? 'RUC' : 'Documento de cliente'"
                  :placeholder="isFactura ? 'Digite RUC' : 'Digite documento'"
                  v-model="sale_new.entity_document"
                  @keypress.enter="mtdSearchDocument"
                />
                <div
                  v-if="
                    isFactura &&
                    isRUCValid &&
                    this.sale_new.entity_document &&
                    this.sale_new.entity_document.length !== 11
                  "
                  class="text-danger"
                >
                  El RUC debe contener solo números y hasta 11 dígitos.
                </div>
              </CCol>
              <CCol sm="12" lg="8">
                <CInput
                  :label="isFactura ? 'Razón social' : 'Nombre Cliente'"
                  :placeholder="isFactura ? 'Digite razón social' : 'nombre'"
                  v-model="sale_new.entity_name"
                  disabled
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="6">
                <label for="adjustmentOption">Tipo de descuento</label>
                <select
                  id="adjustmentOption"
                  v-model="option"
                  class="form-control"
                >
                  <option
                    v-for="(item, index) in options"
                    :key="index"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </CCol>
              <CCol lg="6">
                <CInput
                  label="Monto a descontar"
                  type="number"
                  min="0"
                  placeholder="0.00"
                  v-model="adjustmentAmount"
                  @blur="updateAjustment"
                  :disabled="cpAdjunstmentAmount"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="4">
                <h6>MÉTODO DE PAGO</h6>
                <table>
                  <tbody v-if="data_metodo_pago.length == 0">
                    <tr>
                      <td>Sin Metodos de Pago (Agregue en Mantenimiento)</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr v-for="(item, index) in data_metodo_pago" :key="index">
                      <td v-if="item.label != 'MIXTO'">{{ item.label }}</td>
                      <td v-if="item.label != 'MIXTO'">
                        <input
                          type="number"
                          class="form-control"
                          placeholder="0"
                          v-model="item.amount"
                          @keyup="updateSelectedPayments(item)"
                          min="0"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>PENDIENTE COMPLETAR</td>
                      <td>
                        <input
                          class="form-control"
                          v-model="cpPendingPayment"
                          disabled
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CCol>
              <div class="col-lg-8 col-12">
                <div class="row">
                  <div class="col-lg-4 col-12">
                    <div class="mb-3">
                      <CInput
                        label="TOT. VENTA"
                        :value="cpTotalComand"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-12">
                    <div class="mb-3">
                      <CInput label="PAGADO" :value="pagoCliente" readonly />
                    </div>
                  </div>
                  <div class="col-lg-4 col-12">
                    <div class="mb-3">
                      <CInput label="PENDIENTE" :value="pendiente" readonly />
                    </div>
                  </div>
                  <div class="col-lg-4 col-12">
                    <div class="mb-3">
                      <CInput
                        label="AJUSTE"
                        :value="parseFloat(sale_new.adjustment).toFixed(2)"
                        readonly
                      />
                    </div>
                  </div>
                  <CCol sm="4">
                    <div class="mb-3">
                      <CInput label="TOT. PAGAR" :value="pagoTotal" readonly />
                    </div>
                  </CCol>
                  <CCol sm="4">
                    <CInput label="VUELTO S/" :value="cpVuelto" readonly />
                  </CCol>
                  <!-- <CCol
                    v-if="this.turned.amount > 0 && this.paymentEfectivo()"
                    sm="12"
                  >
                    <CSelect
                      label="Método de pago del vuelto"
                      :value.sync="turned.method"
                      :options="turnedMethod"
                      placeholder="--Seleccione un metodo--"
                    />
                  </CCol> -->
                </div>
              </div>
            </CRow>
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <button class="btn btn-danger" @click="modalFull.showModal = false">
          <i class="fas fa-times"></i> Salir
        </button>
        <button
          @click="mtd_action"
          :disabled="cpButton"
          class="btn btn-info btn-info"
        >
          <i class="fas fa-dollar-sign"></i>Guardar venta
        </button>
      </template>
    </cModalFullComand>
  </CRow>
</template>

<script>
import { mapActions } from "vuex";
import cModalFullComand from "./modals/cModalFullComand.vue";
import moment from "moment";

export default {
  name: "mozo-home-drop",
  components: { cModalFullComand },
  data() {
    return {
      prefix: "mozo",
      level: [],
      posSelectLevel: -1,
      posSelectTable: -1,
      command: [],
      sale_id: 0,
      modalFull: {
        title: "",
        showModal: false,
      },
      /** pago */
      sale_new: {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        user_id: this.$store.getters.get__user_id,
        document_type_id: "",
        date: "",
        type: 0,
        total: "",
        amount: 0,
        pending: 0,
        typeAjustment: 0 /** tipo de ajuste % o S/ */,
        adjustment: 0 /** monto de ajuste */,
        new_pending: "" /** pendiente luego del ajuste */,
        pendigPayment: 0,
        ruc: "",
        state: 0,
        entity_document: "",
        entity_name: "",
        entity_address: "",
        bead_id: "",
        option: 0,
      },
      data_comprobante_pago: [],
      option: 0,
      options: [
        { label: "[Escoja una opción..]", value: 0 },
        { label: "Soles", value: 1 },
        { label: "%", value: 2 },
      ],
      adjustmentAmount: 0,
      data_comprobante_pago: [],
      data_metodo_pago: [],
      selectedPayments: [],
      isRUCValid: true, // Variable para el estado de validación
      turnedMethod: [],
      turned: {
        amount: 0,
        method: 0,
      },
      pendingPayment: 0,
    };
  },
  created() {
    this.mtdGetData();
  },
  computed: {
    cpTotalComand() {
      let total = 0;
      this.command.forEach((element) => {
        total += parseFloat(element.quantity * element.price);
      });
      this.sale_new.total = total;
      this.sale_new.pending = total;
      return parseFloat(total).toFixed(2);
    },
    /** pago */
    isFactura() {
      return this.sale_new.document_type_id == 2; // Asume que el ID de Factura es 2
    },
    colClass() {
      const itemsCount = this.data_comprobante_pago.length;
      if (itemsCount === 1) return "col-12";
      if (itemsCount === 2) return "col-6";
      if (itemsCount === 3) return "col-4";
      return "col-6";
    },
    cpButton() {
      if (this.sale_new.document_type_id == 3) {
        return !this.sale_new.document_type_id;
      } else {
        return (
          !this.sale_new.entity_document ||
          !this.sale_new.entity_name ||
          !this.sale_new.document_type_id
        );
      }
    },
    // Suma de los pagos seleccionados
    pagoCliente() {
      return parseFloat(this.sale_new.amount).toFixed(2);
    },
    // Calcular el monto pendiente a pagar
    pendiente() {
      return this.sale_new.total;
    },
    pagoTotal() {
      let tot = 0;
      tot =
        parseFloat(this.sale_new.total) + parseFloat(this.sale_new.adjustment);
      this.sale_new.pendigPayment = parseFloat(tot).toFixed(2);
      return parseFloat(tot).toFixed(2);
    },
    cpVuelto() {
      const totalPayments = this.selectedPayments.reduce(
        (sum, payment) => sum + parseFloat(payment.amount),
        0
      );
      let pend = this.pagoTotal == 0 ? this.sale_new.total : this.pagoTotal;

      if (totalPayments > 0) {
        if (parseFloat(totalPayments - pend).toFixed(2) > 0) {
          this.turned.amount = parseFloat(totalPayments - pend).toFixed(2);
          return parseFloat(totalPayments - pend).toFixed(2);
        } else {
          this.turned.amount = 0;
          return 0;
        }
      }
      this.turned.amount = 0;
      return 0;
    },
    cpPendingPayment() {
      const totalPayments = this.selectedPayments.reduce(
        (sum, payment) => sum + parseFloat(payment.amount),
        0
      );
      if (totalPayments == 0) {
        // this.disabledButton = true;
        return this.pagoTotal == 0
          ? parseFloat(this.sale_new.total).toFixed(2)
          : this.pagoTotal;
      }
      let pendientePago = parseFloat(this.sale_new.pendigPayment);

      let pagosTotales = parseFloat(totalPayments);

      let res =
        pendientePago == 0
          ? (this.sale_new.total - pagosTotales).toFixed(2)
          : (pendientePago - pagosTotales).toFixed(2);

      // this.disabledButton = res <= 0 ? false : true;
      this.pendingPayment = res < 0 ? 0 : res;
      return this.pendingPayment;
    },
    cpAdjunstmentAmount() {
      if (this.option > 0) {
        this.updateAjustment();
        return false;
      }
      this.sale_new.adjustment = 0;
      return true;
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack() {
      this.$emit("returnHome");
    },
    mtdGetData: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.level = response.data.level;
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdSelectLevel: function (pos) {
      (this.posSelectTable = -1), (this.posSelectLevel = pos);
    },
    mtdGetStayteAtention: function (status) {
      const state = Number(status);
      let res = "";
      switch (state) {
        case 1:
          res = "btn btn-success position-absolute text-center";
          break;
        case 2:
          res = "btn btn-danger position-absolute text-center";
          break;
        case 3:
          res = "btn btn-warning position-absolute text-center";
          break;
        default:
          break;
      }
      return res;
    },
    mtdSelectTable: function (pos) {
      this.posSelectTable = pos;
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/getcomand/" +
          this.level[this.posSelectLevel].detalle[this.posSelectTable].id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.command = response.data.comand;
          this.sale_id = response.data.sale;
          this.modalFull.showModal = true;
          this.modalFull.title =
            "Comandas de: " +
            this.level[this.posSelectLevel].detalle[this.posSelectTable].name;
          this.showDocumentType();
          this.showMethodPayment();
          this.showBead();
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdGetClassCommand: function (pos) {
      if (pos == this.posSelectLevel) {
        return "bg-info text-white";
      }
    },
    mtdSetItemCommand: function (itemComand) {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/setitemcomand/" +
          this.level[this.posSelectLevel].detalle[this.posSelectTable].id,
        params: {
          sale_id: this.sale_id,
          item: itemComand,
        },
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.sale_id = response.data.sale;
          this.level[this.posSelectLevel].detalle[
            this.posSelectTable
          ].state_attention = response.data.state_table;
          Swal.fire({
            toast: true,
            position: "center",
            showConfirmButton: false,
            timer: 3000,
            icon: "success",
            title: "Item agregado correctamente!",
            text: "Puedes continuar",
          });
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdGetClassItemCommand: function (state) {
      const parseState = parseInt(state);
      let resClas = "";
      switch (parseState) {
        case 1:
          resClas = "danger";
          break;
        case 2:
          resClas = "warning";
          break;
        case 3:
          resClas = "success";
          break;
        default:
          break;
      }
      return resClas;
    },
    mtdGetStateItemCommand: function (state) {
      const parseState = parseInt(state);
      let resText = "";
      switch (parseState) {
        case 1:
          resText = "Pendiente";
          break;
        case 2:
          resText = "Preparando";
          break;
        case 3:
          resText = "Entregado";
          break;
        default:
          break;
      }
      return resText;
    },
    mtdSelectItemComand: function (payload, pos) {
      if (payload.status == 3 && this.$store.getters.get_rol.id == 1) {
        Swal.fire({
          title: "¿Qué deseas hacer?",
          text: "Puedes aprobar o denegar la solicitud.",
          icon: "question",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Aprobar",
          denyButtonText: "Denegar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#28a745", // verde
          denyButtonColor: "#dc3545", // rojo
          cancelButtonColor: "#6c757d", // gris
        }).then((result) => {
          if (result.isConfirmed) {
            // Acción al aprobar
            this.mtdSetateItem(payload, pos, 1);
          } else if (result.isDenied) {
            // Acción al denegar
            this.mtdSetateItem(payload, pos, 0);
          }
        });
      } else {
        this.mtdChangePriceItem(payload, pos);
        // Swal.fire({
        //   toast: true,
        //   position: "center",
        //   showConfirmButton: false,
        //   timer: 3000,
        //   icon: "warning",
        //   title: "No puede editar!!",
        //   text: "",
        // });
      }
    },
    mtdUpItemCommand: function (payload, pos) {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/upitemcomand",
        params: payload,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.command[pos].quantity = payload.quantity;
            this.command[pos].anotation = payload.anotation;
            Swal.fire({
              toast: true,
              position: "center",
              showConfirmButton: false,
              timer: 3000,
              icon: "success",
              title: "Item editado correctamente!",
              text: "Puedes continuar",
            });
          } else {
            Swal.fire({
              toast: true,
              position: "center",
              showConfirmButton: false,
              timer: 3000,
              icon: "success",
              title: "ups!! Algo salió mal!!",
              text: response.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdDeleteItemCommand: function (payload, pos) {
      this.post({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/delitemcomand",
        params: payload,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            if (response.data.booPermiso == 0) {
              Swal.fire({
                toast: true,
                position: "center",
                showConfirmButton: false,
                timer: 3000,
                icon: "success",
                title: "Item borrado correctamente!",
                text: "Puedes continuar",
              });
              this.command.splice(pos, 1);
            } else {
              Swal.fire({
                toast: true,
                position: "center",
                showConfirmButton: false,
                timer: 3000,
                icon: "warning",
                title: "Solicitud registrada correctamente!",
                text: "Debe esperar a que se acepte.",
              });
            }
          } else {
            Swal.fire({
              toast: true,
              position: "center",
              showConfirmButton: false,
              timer: 3000,
              icon: "success",
              title: "ups!! Algo salió mal!!",
              text: response.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdSetateItem: function (payload, pos, action) {
      this.post({
        url:
          this.$store.getters.get__url + "/recepcionist/upitemstate/" + action,
        params: {
          det: payload.idDet,
        },
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            if (action == 0) {
              this.command[pos].status = 1;
            } else {
              this.command.splice(pos, 1);
            }
            let acc = action == 0 ? "denegada" : "aprobada";
            Swal.fire({
              toast: true,
              position: "center",
              showConfirmButton: false,
              timer: 3000,
              icon: "success",
              title: "Solicitud " + acc + " correctamente!",
            });
          } else {
            Swal.fire({
              toast: true,
              position: "center",
              showConfirmButton: false,
              timer: 3000,
              icon: "success",
              title: "ups!! Algo salió mal!!",
              text: response.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    /** pago */
    resetFormData() {
      this.sale_new = {
        id: this.sale_id,
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        user_id: this.$store.getters.get__user_id,
        document_type_id: "",
        date: "",
        type: 0,
        total: "",
        amount: 0,
        pending: 0,
        typeAjustment: 0 /** tipo de ajuste % o S/ */,
        adjustment: 0 /** monto de ajuste */,
        new_pending: "" /** pendiente luego del ajuste */,
        pendigPayment: 0,
        ruc: "",
        state: 0,
        entity_document: "",
        entity_name: "",
        entity_address: "",
        bead_id: "",
        option: 0,
      };
      // this.adjustmentType = 0;
      this.option = 0;
      this.adjustmentAmount = 0;
      this.selectedPayments = [];
      this.turnedMethod = [];
      this.data_comprobante_pago = [];
      this.data_metodo_pago = [];
    },
    showDocumentType() {
      this.get({
        url: this.$store.getters.get__url + "/sales/byDocumentType",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          let defaultIndex = null;
          this.data_comprobante_pago = [];
          response.data.data.forEach((arr, index) => {
            const { id, name } = arr;
            const selected = name === "NOTA DE VENTA";
            if (selected) defaultIndex = id;

            this.data_comprobante_pago.push({
              label: name,
              value: id,
              selected: selected,
            });
          });

          if (defaultIndex !== null) {
            this.selectItem(defaultIndex);
          }
        })
        .catch((errors) => {});
    },
    selectItem(index) {
      this.sale_new.document_type_id = index;
      this.data_comprobante_pago.forEach((item) => {
        item.selected = item.value === index;
      });

      // Resetear los valores según el tipo de comprobante seleccionado
      if (this.isFactura) {
        this.isRUCValid = true; // Reinicia la validación del RUC
      }
      this.sale_new.entity_document = "";
      this.sale_new.entity_name = "";
    },
    mtdSearchDocument: async function () {
      if (this.sale_new.document_type_id === 1) {
        this.mtdSearchClientByDniOrCE();
      } else if (this.sale_new.document_type_id === 2) {
        await this.mtdSearchClientByNumberRuc();
      } else if (this.sale_new.document_type_id === 3) {
        if (
          this.sale_new.entity_document.length === 8 ||
          this.sale_new.entity_document.length === 11 ||
          this.sale_new.entity_document.length === 0
        ) {
          if (this.sale_new.entity_document.length === 0) {
            this.sale_new.entity_document = "11111111";
          }
          await this.get({
            url:
              this.$store.getters.get__url +
              "/Consultas/" +
              this.sale_new.entity_document,
            token: this.$store.getters.get__token,
          }).then((response) => {
            if (response.data.boo === 3) {
              this.sale_new.entity_document = "";
              this.sale_new.entity_name = "";
              this.sale_new.entity_address = "";
              Swal.fire({
                title: "DNI no encontrado",
                icon: "warning",
              });
            } else {
              let name =
                this.sale_new.entity_document.length == 8
                  ? response.data.name + " " + response.data.last_name
                  : response.data.razon_social;
              this.sale_new.entity_name = name;
              this.sale_new.entity_address = response.data.direccion ?? "";
            }
          });
        }
      }
    },
    mtdSearchClientByDniOrCE() {
      if (this.sale_new.entity_document.length === 0) {
        Swal.fire({
          title: "El número de documento no debe estar vacío",
          icon: "error",
        });
        return;
      }

      let documentLength = this.sale_new.entity_document.length;

      switch (documentLength) {
        case 8:
          //Buscar persona por DNI
          this.mtdSearchClientByDni();
          break;
        case 9:
          //Buscar personal por CE
          this.mtdSearchClientByCE();
          break;
        default:
          this.sale_new.entity_name = "";
          this.sale_new.entity_address = "";
          break;
      }
    },
    mtdSearchClientByDni: async function () {
      await this.get({
        url: `${this.$store.getters.get__url}/Consultas/${this.sale_new.entity_document}`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.data.boo === 3) {
          this.sale_new.entity_document = "";
          this.sale_new.entity_name = "";
          this.sale_new.entity_address = "";

          Swal.fire({
            title: "DNI no encontrado",
            icon: "warning",
          });
        } else {
          this.sale_new.entity_name =
            response.data.name + " " + response.data.last_name;
          this.sale_new.entity_address = response.data.direccion ?? "";
        }
      });
    },
    mtdSearchClientByCE: function () {
      this.get({
        url: `${this.$store.getters.get__url}/Consultas/searchCe/${this.sale_new.entity_document}`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode !== 200) {
          Swal.fire({
            title: "Documento no encontrado",
            icon: "warning",
          });
          this.sale_new.entity_document = "";
          this.sale_new.entity_name = "";
          this.sale_new.entity_address = "";
          return;
        }

        this.sale_new.entity_name = response.data.name;
      });
    },
    mtdSearchClientByNumberRuc: async function () {
      if (this.sale_new.entity_document.length !== 11) {
        Swal.fire({
          title: "El número de RUC debe tener 11 dígitos",
          icon: "error",
        });
        return;
      }

      await this.get({
        url:
          this.$store.getters.get__url +
          "/Consultas/" +
          this.sale_new.entity_document,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.data.boo === 3) {
          this.sale_new.entity_document = "";
          this.sale_new.entity_name = "";
          this.sale_new.entity_address = "";
          Swal.fire({
            title: "RUC no encontrado",
            icon: "warning",
          });
        } else {
          this.sale_new.entity_name = response.data.razon_social;
          this.sale_new.entity_address = response.data.direccion ?? "";
        }
      });
    },
    updateAjustment() {
      // this.sale_new.typeAjustment = this.adjustmentType;
      this.sale_new.adjustment = 0;
      let adjustmentAmount = parseFloat(this.adjustmentAmount) || 0;
      if (this.option == 1) {
        /** soles */
        this.sale_new.adjustment = parseFloat(adjustmentAmount * -1).toFixed(2);
      } else {
        /** % */
        const total = this.sale_new.total;
        let tempAdjustment = (total * adjustmentAmount) / 100;
        this.sale_new.adjustment = parseFloat(tempAdjustment * -1).toFixed(2);
      }
    },
    showMethodPayment() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/sales/byMethodPayment/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data_metodo_pago = [];
          response.data.data.forEach((arr) => {
            const { id, name } = arr;
            this.data_metodo_pago.push({
              label: name,
              value: id,
              amount: "",
            });
            this.turnedMethod.push({
              label: name,
              value: id,
            });
          });
        })
        .catch((errors) => {});
    },
    updateSelectedPayments(item) {
      if (item.amount < 0) {
        item.amount = 0;
        return;
      }
      // Elimina cualquier elemento existente con el mismo ID
      if (item.amount === "" || parseFloat(item.amount) === 0) {
        this.selectedPayments = this.selectedPayments.filter(
          (payment) => payment.id !== item.value
        );
        return;
      }
      let newTotal;
      if (item.amount) {
        // Elimina cualquier elemento existente con el mismo ID
        this.selectedPayments = this.selectedPayments.filter(
          (payment) => payment.id !== item.value
        );

        newTotal =
          this.selectedPayments.reduce(
            (sum, payment) => sum + parseFloat(payment.amount),
            0
          ) + parseFloat(item.amount);
      }
      // Agregue así exceda
      if (item.amount > 0) {
        this.selectedPayments.push({
          id: item.value,
          label: item.label,
          amount: item.amount,
        });
      }
    },
    paymentEfectivo() {
      return (
        this.selectedPayments.length > 0 &&
        this.selectedPayments.every((payment) => payment.label === "EFECTIVO")
      );
    },
    mtd_action: async function () {
      let boo = this.mtdVerifDataSale();
      if (parseFloat(this.pendingPayment) > 0.0) {
        Swal.fire({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 3000,
          icon: "warning",
          title: "No se puede pagar menos del total!",
          text: "Corregir montos",
        });
        return;
      }
      if (boo == true) {
        this.sale_new.date = moment().format("YYYY-MM-DD HH:mm:ss");
        this.sale_new.type = 0; //mejor hacerlo en el back
        this.sale_new.option = this.option;
        if (this.option == 1) {
          this.sale_new.adjustment = parseFloat(
            this.adjustmentAmount * -1
          ).toFixed(2);
        } else {
          const total = this.sale_new.total;
          let tempAdjustment = (total * this.adjustmentAmount) / 100;
          this.sale_new.adjustment = parseFloat(tempAdjustment * -1).toFixed(2);
        }
        let resWsp = [];
        let nameWsp = "";
        this.sale_new.id = this.sale_id;
        await this.post({
          url: this.$store.getters.get__url + "/recepcionist/store/saleComand",
          token: this.$store.getters.get__token,
          params: {
            sale: this.sale_new,
            saleDetail: this.command,
            charge: this.selectedPayments,
            turned: this.turned,
          },
        }).then((response) => {
          let color = "";
          let message = "";

          if (response.statusCode == 200 && response.data.data !== null) {
            if (
              response.data.state == 1 ||
              response.data.state == 2 ||
              response.data.state == 3
            ) {
              message = response.message;
              Swal.fire({
                title: message,
                icon: "error",
              });
            } else {
              color = "success";
              message = "REGISTRADO CORRECTAMENTE";
              resWsp = response;
              nameWsp = this.sale_new.entity_name;
            }
          } else {
            color = "error";
            message = "error";
          }
          // Reseteamos la data
          this.resetFormData();
          this.selectedPayments = [];
          this.modalFull.showModal = false;
          this.mtdGetData();
          if (color == "success") {
            this.mtdProccessSaleResponse(resWsp, nameWsp);
          } else {
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        });
      }
    },
    mtdVerifDataSale: function () {
      let boo = true;
      this.sale_new.pendingPaymentCalculated = this.cpPendingPayment;
      if (this.command.length <= 0) {
        Swal.fire({
          title: "No tiene productos en el carrito de venta.",
          icon: "error",
        });
      }
      if (
        this.isFactura &&
        this.isRUCValid &&
        this.sale_new.entity_document &&
        this.sale_new.entity_document.length != 11
      ) {
        Swal.fire({
          title: "El RUC no es válido. Debe tener 11 dígitos.",
          icon: "error",
        });
        boo = false;
      } else if (
        this.sale_new.entity_document == "" ||
        this.sale_new.entity_name == ""
      ) {
        Swal.fire({
          title: "Agregue datos del cliente",
          icon: "error",
        });
        boo = false;
      }
      // if (
      //   this.turned.amount > 0 &&
      //   this.turned.method == 0 &&
      //   this.turned.amount
      // ) {
      //   Swal.fire({
      //     title: "Agregue metodo de pago para el vuelto",
      //     icon: "error",
      //   });
      //   boo = false;
      // }
      return boo;
    },
    mtdProccessSaleResponse: async function (response, name) {
      const result = await Swal.fire({
        title: "Venta Finalizada",
        text: "Seleccione una opción",
        icon: "success",
        showCancelButton: true,
        showDenyButton: false,
        confirmButtonText: '<i class="fas fa-file-pdf"></i> Imprimir PDF',
        cancelButtonText: '<i class="fab fa-whatsapp"></i> Enviar a WhatsApp',
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-success",
          actions: "d-flex justify-content-between gap-2",
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: true,
        showCloseButton: true,
      });
      if (result.isConfirmed) {
        if (response.data.document_type_id == 3) {
          this.openTicket(response.data.voucher_id);
        } else {
          let res = response.data.data.sunat;
          window.open(res.json.enlace_del_pdf_ticket, "_blank");
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        let phone = null;
        if (!phone) {
          await Swal.fire({
            title: "No hay número registrado",
            text: "Por favor, ingresa un número de teléfono para enviar el comprobante.",
            icon: "warning",
            input: "text",
            inputPlaceholder: "Ingrese su número de teléfono",
            showCancelButton: true,
          }).then(async (inputResult) => {
            if (inputResult.isConfirmed && inputResult.value) {
              phone = inputResult.value;
            } else {
              return;
            }
          });
        } else {
          await Swal.fire({
            title: "Confirmar número de teléfono",
            text: "Por favor, revisa o edita el número de teléfono antes de enviar el comprobante.",
            icon: "info",
            input: "text",
            inputValue: phone,
            showCancelButton: true,
          }).then(async (inputResult) => {
            if (inputResult.isConfirmed && inputResult.value) {
              phone = inputResult.value;
            } else {
              return;
            }
          });
        }
        let urlPdf = "";
        let res = response.data.data.sunat;
        if (response.data.document_type_id == 3) {
          urlPdf =
            this.$store.getters.get__url +
            "/sales/ticket/" +
            response.data.voucher_id +
            "/" +
            this.$store.getters.get__user_id;
        } else {
          urlPdf = res.json.enlace_del_pdf_ticket;
        }
        await this.post({
          url: this.$store.getters.get__url + "/send/wsp/sale",
          token: this.$store.getters.get__token,
          params: {
            phone: phone,
            fileUrl: urlPdf,
            filename: `${response.data.data.serie}-${response.data.data.number}.pdf`,
            message: `Hola ${name}, te enviamos el comprobante de tu compra en *AQ Industrias*. \nGracias por tu preferencia. \n¡Quedamos atentos para cualquier consulta!.\nSaludos`,
          },
        });

        await Swal.fire({
          title: "Mensaje enviado",
          text:
            "El comprobante electrónico se ha enviado correctamente a " + phone,
          icon: "success",
        });
      }
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showBead/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          let bead = response.data;
          this.sale_new.bead_id = bead.id;
        })
        .catch((errors) => {});
    },
    openTicket(id) {
      window.open(
        this.$store.getters.get__url +
          "/sales/ticket/" +
          id +
          "/" +
          this.$store.getters.get__user_id,
        "_blank"
      );
    },
    // mtdSelectItemComand: function (payload, pos) {
    //   // Mostrar modal para cambiar precio del item
    //   this.mtdChangePriceItem(payload, pos);
    // },
    mtdGetClassItemCommand: function (state) {
      const parseState = parseInt(state);
      let resClas = "";
      switch (parseState) {
        case 1:
          resClas = "danger";
          break;
        case 2:
          resClas = "warning";
          break;
        case 3:
          resClas = "success";
          break;
        default:
          break;
      }
      return resClas;
    },
    mtdGetStateItemCommand: function (state) {
      const parseState = parseInt(state);
      let resText = "";
      switch (parseState) {
        case 1:
          resText = "Pendiente";
          break;
        case 2:
          resText = "Preparando";
          break;
        case 3:
          resText = "Entregado";
          break;
        default:
          break;
      }
      return resText;
    },
    // Método para cambiar precio de un item en el proceso de cobro
    mtdChangePriceItem: function (payload, pos) {
      Swal.fire({
        title: "Cambiar Precio",
        html: `
          <div style="text-align: left; margin-bottom: 15px; padding: 10px; background: #f8f9fa; border-radius: 8px;">
            <p style="margin: 5px 0;"><b>Producto:</b> ${payload.name}</p>
            <p style="margin: 5px 0;"><b>Cantidad:</b> ${payload.quantity}</p>
            <p style="margin: 5px 0; color: #17a2b8;"><b>Precio actual:</b> S/ ${parseFloat(
              payload.price
            ).toFixed(2)}</p>
            <p style="margin: 5px 0; color: #666;"><b>Subtotal actual:</b> S/ ${parseFloat(
              payload.price * payload.quantity
            ).toFixed(2)}</p>
          </div>
          <input 
            id="new-price-input" 
            class="swal2-input" 
            type="number" 
            step="0.01" 
            min="0"
            placeholder="Ingrese nuevo precio"
            value="${payload.price}"
            style="font-size: 18px; font-weight: bold; text-align: center;"
            autofocus
          >`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "✓ Cambiar Precio",
        cancelButtonText: "Cancelar",
        showClass: {
          popup: "animate__animated animate__zoomIn animate__faster",
        },
        hideClass: {
          popup: "animate__animated animate__zoomOut animate__faster",
        },
        didOpen: () => {
          // Auto-seleccionar el input para facilitar la edición
          const input = document.getElementById("new-price-input");
          if (input) {
            input.focus();
            input.select();
          }
        },
        preConfirm: () => {
          const newPrice =
            document.getElementById("new-price-input")?.value || "";

          if (!newPrice || parseFloat(newPrice) <= 0) {
            Swal.showValidationMessage("Ingrese un precio válido mayor a 0");
            return null;
          }

          return { newPrice: parseFloat(newPrice) };
        },
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          this.post({
            url: this.$store.getters.get__url + "/recepcionist/updateitemprice",
            params: {
              idDet: payload.idDet,
              idSale: this.sale_id,
              new_price: result.value.newPrice,
            },
            token: this.$store.getters.get__token,
          })
            .then((response) => {
              if (response.statusCode == 200) {
                // Actualizar precio en la vista
                this.command[pos].price = result.value.newPrice;

                Swal.fire({
                  title: "¡Precio actualizado!",
                  html: `
                  <div style="padding: 10px;">
                    <p><b>Producto:</b> ${payload.name}</p>
                    <p style="color: #dc3545; text-decoration: line-through;"><b>Anterior:</b> S/ ${parseFloat(
                      payload.price
                    ).toFixed(2)}</p>
                    <p style="color: #28a745; font-size: 20px;"><b>Nuevo:</b> S/ ${result.value.newPrice.toFixed(
                      2
                    )}</p>
                    <p style="margin-top: 10px;"><b>Nuevo subtotal:</b> S/ ${parseFloat(
                      result.value.newPrice * payload.quantity
                    ).toFixed(2)}</p>
                  </div>
                `,
                  icon: "success",
                  timer: 2500,
                  showConfirmButton: false,
                  showClass: {
                    popup: "animate__animated animate__bounceIn",
                  },
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                title: "Error",
                text:
                  error.response?.data?.data?.error_message ||
                  "No se pudo actualizar el precio",
                icon: "error",
                confirmButtonColor: "#dc3545",
              });
            });
        }
      });
    },
  },
};
</script>


<style scoped>
.bg-purple {
  background-color: #926cdc;
}

.bg-white {
  background-color: white;
}

.bg-gris {
  background-color: #dee2e6;
}

.color-white {
  color: white;
}

.color-black {
  color: black;
}

.font-bold {
  font-weight: bold;
}

.container-type {
  height: 40px;
}

.container-type:hover {
  background-color: #17a2b8;
  /* bg-info */
  cursor: pointer;
}

.text {
  margin: auto;
}
</style>

